import { themeLss } from "../../lss";
import styled from '../../styled';
export var Icon = styled.svg(themeLss());
//# sourceMappingURL=Icon.js.map